export class GCSBucket {
    'bucketName';
    'location';
    'locationType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "locationType",
            "baseName": "locationType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GCSBucket.attributeTypeMap;
    }
    constructor() {
    }
}
